import * as React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import { Trad } from "src/components";

export const GetGroupListColumns = () => [
    {
        name: "ID_Gruppo",
        label: "ID",
        options: {
            filter: false
        }
    },
    {
        name: "Gruppo",
        label: Trad.Trad("Nome"),
        options: {
            filter: false
        }
    },

    {
        name: "ID_Gruppo",
        label: Trad.Trad("Modifica"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string) => (
                <a href={`/Gruppo/${val}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </a>
            )
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/SearchTableColumns/GroupListColumns.tsx